/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { hatsAppStrictHttpResponse } from '../../hats-app-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OptInRequest } from '../../models/opt-in-request';
import { OptInResponse } from '../../models/opt-in-response';

export interface ApiConsumerWhatsappOptinPost$Params {
  
    /**
     * Optional date of birth and gender to set or update on the member profile.
     */
    body?: OptInRequest
}

export function apiConsumerWhatsappOptinPost(http: HttpClient, rootUrl: string, params?: ApiConsumerWhatsappOptinPost$Params, context?: HttpContext): Observable<hatsAppStrictHttpResponse<OptInResponse>> {
  const rb = new RequestBuilder(rootUrl, apiConsumerWhatsappOptinPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as hatsAppStrictHttpResponse<OptInResponse>;
    })
  );
}

apiConsumerWhatsappOptinPost.PATH = '/api/consumer/whatsapp/optin';
